import { render, staticRenderFns } from "./ProgramPageWrapper.vue?vue&type=template&id=4eea62fd"
import script from "./ProgramPageWrapper.vue?vue&type=script&lang=js"
export * from "./ProgramPageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports